<template>
  <div class="container-fluid">
    <b-row>
      <b-col cols="4">
        <h1>Order Pipeline</h1>
        <h3>{{ fishbowlOrderPipeline.length }} Orders</h3>
      </b-col>
      <b-col cols="8">
        <b-row>
          <b-col cols="12" md="2">
            <b-badge variant="success">Issued</b-badge> {{this.counts.issued}} 
          </b-col>
          <b-col cols="12" md="2">
            <b-badge variant="primary">Picking</b-badge> {{this.counts.picking}}
          </b-col>
          <b-col cols="12" md="2">
            <b-badge variant="primary">Packing</b-badge> {{this.counts.packing}}
          </b-col>
          <b-col cols="12" md="2">
            <b-badge variant="success">Shipping Today</b-badge> {{this.counts.shipping}}
          </b-col>
          <b-col cols="12" md="2">
            <b-badge variant="dark">Backorder</b-badge> {{this.counts.backorder}}
          </b-col>
          <b-col cols="12" md="2">
            <b-badge variant="danger">???</b-badge> {{this.counts.unknown}}
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-table
      striped
      hover
      class="wide-table"
      :items="fishbowlOrderPipeline"
      sort-by.sync=""
      :fields="columns"
      sort-by="datecreated"
      :sort-desc="true"
    >
      <template
        slot="computedstatus"
        slot-scope="data"
      >
        <FishbowlStatus :order="data.item" />
      </template>
      <template
        slot="sonum"
        slot-scope="data"
      >
        <router-link
          target="_blank"
          :to="{ name: 'View Order', params: { id: data.item.sonum} }"
        >
          {{ data.item.sonum }}
        </router-link>
      </template>
      <template slot="datecreated" slot-scope="data">
        <NiceDate :value="data.item.datecreated" />
      </template>
      <template slot="dateissued" slot-scope="data">
        <NiceDate :value="data.item.dateissued" />
      </template>
      <template slot="pickStart" slot-scope="data">
        <NiceDate :value="data.item.pickStart" />
      </template>
      <template slot="shipCreate" slot-scope="data">
        <NiceDate :value="data.item.shipCreate" />
      </template>
      <template slot="totalPrice" slot-scope="data">
        {{Number(data.item.totalPrice) | formatDollars}}
      </template>
    </b-table>
  </div>

</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import dateFormat from 'dateformat';

import Constants from '../../../../constants.js';
import FishbowlStatus from '../../utility/FishbowlStatus';
import NiceDate from '../../utility/NiceDate';

export default {
  data() {
    return {
      counts: {
        issued: 0,
        picking: 0,
        packing: 0,
        shipping: 0,
        backorder: 0,
        unknown: 0,
        buckets: {},
      },
      columns: [
        { key: 'sonum', label: 'OrderNum', sortable: true },
        { key: 'computedstatus', label: 'Status', sortable: true },
        { key: 'totalPrice', label: 'Total $', sortable: true },
        { key: 'paymentterms', label: 'PaymentMethod', sortable: true },
        { key: 'datecreated', label: 'Created', sortable: true },
        { key: 'dateissued', label: 'Issued', sortable: true },
        { key: 'pickStart', label: 'PickStart', sortable: true },
        { key: 'shipCreate', label: 'ShipStart', sortable: true },
      ],
    };
  },
  components: {
    FishbowlStatus,
    NiceDate,
  },
  watch: {
    fishbowlOrderPipeline() {
      this.counts.issued = 0;
      this.counts.picking = 0;
      this.counts.packing = 0;
      this.counts.shipping = 0;
      this.counts.backorder = 0;
      this.counts.unknown = 0;
      
      Object.keys(this.counts.buckets).forEach( (k) => { this.counts.buckets[k] = 0});

      this.fishbowlOrderPipeline.forEach( i => {
        const itemShort = (i.itemStatus ? i.itemStatus.split('|').map( i => +i) : []).includes(5);
        const key = itemShort ? 'short' : `${i.soStatus}!${i.pickStatus ? Math.min(...i.pickStatus.split('|')) : ''}!${i.shipStatus ? Math.min(...i.shipStatus.split('|')) : ''}`;
        if(!this.counts.buckets[key]) { this.counts.buckets[key] = 0; }
        this.counts.buckets[key] += 1;
      });

      this.counts.issued = 
          (this.counts.buckets['20!!']  || 0)
        + (this.counts.buckets['20!10!'] || 0);
      this.counts.shipping = 
        (this.counts.buckets['25!40!20'] || 0);
        (this.counts.buckets['25!30!20'] || 0);
      this.counts.backorder = 
          (this.counts.buckets['short'] || 0)
        + (this.counts.buckets['25!10!30'] || 0)
        + (this.counts.buckets['25!20!30'] || 0)
        + (this.counts.buckets['25!30!10'] || 0)
        + (this.counts.buckets['25!30!30'] || 0);
      this.counts.picking = 
          (this.counts.buckets['20!20!'] || 0)
        + (this.counts.buckets['20!20!10'] || 0)
        + (this.counts.buckets['20!20!20'] || 0)
        + (this.counts.buckets['25!10!10'] || 0)
        + (this.counts.buckets['25!20!'] || 0)
        + (this.counts.buckets['25!20!10'] || 0)
        + (this.counts.buckets['25!20!20'] || 0)
        + (this.counts.buckets['25!30!'] || 0);
      this.counts.packing = 
        + (this.counts.buckets['25!10!10'] || 0)
        + (this.counts.buckets['25!10!20'] || 0)
        + (this.counts.buckets['25!40!10'] || 0);

      this.unknown = this.fishbowlOrderPipeline.length - this.counts.issued
        - this.counts.shipping - this.counts.backorder
        - this.counts.picking - this.counts.packing;
    }
  },
  computed: {
    ...mapGetters({
      fishbowlOrderPipeline: 'fishbowlOrderPipeline',
    }),
  },
  methods: {
    ...mapActions({
      getFishbowlOrderPipeline: 'getFishbowlOrderPipeline',
    }),
  },
  mounted() {
    this.getFishbowlOrderPipeline();
    setInterval(() => { this.getFishbowlOrderPipeline(); }, 1000 * 90);
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/sales-order/reports/OrderPipeline.vue